"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "setUserBackground", {
  enumerable: true,
  get: function get() {
    return _setUserBackground["default"];
  }
});
var _setUserBackground = _interopRequireDefault(require("./setUserBackground"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }